import React, { Component } from 'react'
import { connect } from 'react-redux'

import CharacterDropIn from '../components/CharacterDropIn'

class Home extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return(
            <div>
                <nav className="pt-navbar">
                    <div className="pt-navbar-group pt-align-left">
                        <div className="pt-navbar-heading">
                            <b><CharacterDropIn value={'Jamal Mahboob: Home'} /></b>
                        </div>
                    </div>
                </nav>
                <div className='center-center pt-card pt-interactive pt-elevation-2 pt-dark nomatch'>
                    <div className='pt-button-group pt-vertical'>
                        <button className='pt-icon pt-icon-build pt-button pt-dark pt-minimal' onClick={() => window.location.href="/#/testbed"}>TestBed</button>
                        <hr />
                        <button className='pt-icon pt-icon-send-to-graph pt-button pt-dark pt-minimal' onClick={() => window.location.href="/#/graphistry"}>Graphistry - Map</button>
                        <button className='pt-icon pt-icon-send-to-graph pt-button pt-dark pt-minimal' onClick={() => window.location.href="/#/graphistry_wlan"}>Graphistry - 802.11 WLAN</button>
                        <button className='pt-icon pt-icon-send-to-graph pt-button pt-dark pt-minimal' onClick={() => window.location.href="/#/graphistry_mario"}>Graphistry - Mario ASM</button>
                        <hr/>
                        <button className='pt-icon pt-icon-code pt-button pt-dark pt-minimal' onClick={() => window.location.href="https://github.com/jmahboob"}>GitHub</button>
                        <button className='pt-icon pt-icon-camera pt-button pt-dark pt-minimal' onClick={() => window.location.href="http://www.jamalmahboob.com/?cat=33"}>Photos</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/containers/Home.js